// extracted by mini-css-extract-plugin
export var createdDate = "_en-1";
export var divider = "_en-2";
export var headerDivider = "_en-3";
export var messagesCard = "_en-0";
export var messagesContainer = "_en-7";
export var messagesContainerWrapper = "_en-4";
export var pointerCapturingButtonBoxes = "_en-a";
export var showLeftPanelButton = "_en-9";
export var showMoreButton = "_en-c";
export var showMoreButtonContainer = "_en-b";
export var summaryTitle = "_en-6";
export var systemMessageCardWrapper = "_en-d";
export var topButtons = "_en-8";
export var withPadding = "_en-5";